/* @HEADER
 * @version 0.15.943 | 2026-07-15
 * @purpose Describe the role of ZvenixLogo in this repository.
 * @sidecar ZvenixLogo.tsx.header.md
 * @layer app | @hex _none_ | @ctx _none_
 * @public false
 * @edit careful
 */

/**
 * Zvenix logo — "Trail-Z" brand mark: the letter Z traced as a single
 * path with node waypoints at each vertex (indigo path, teal endpoint
 * nodes, indigo center node). Chosen by the product owner as the in-app
 * logo mark. Source concept archived at
 * docs/design/icons/drafts/zvenix-z-trail.svg.
 */

export function ZvenixLogo({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 64 64"
      fill="none" xmlns="http://www.w3.org/2000/svg"
      aria-label="Zvenix"
    >
      <polyline points="16,18 48,18 16,46 48,46" fill="none" stroke="#4c6ef5" strokeWidth="5.5"
        strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="16" cy="18" r="4" fill="#4c6ef5" />
      <circle cx="48" cy="46" r="4" fill="#4c6ef5" />
      <circle cx="48" cy="18" r="6.5" fill="#22b8cf" stroke="#fff" strokeWidth="2" />
      <circle cx="16" cy="46" r="6.5" fill="#22b8cf" stroke="#fff" strokeWidth="2" />
      <circle cx="32" cy="32" r="5.5" fill="#4c6ef5" stroke="#fff" strokeWidth="2" />
    </svg>
  )
}
